<div class="ui-alert-wrapper" [ngClass]="[typeClass(), colorClass(), mobileClass()]" role="alert">
  @if (icon()) {
    <div class="ui-alert-icon">
      <ui-icon [icon]="icon()!" />
    </div>
  }

  <div class="ui-alert-content">
    @if (title()) {
      <span class="text-base font-medium text-text-primary">{{ title() }}</span>
    }
    @if (message()) {
      <span class="text-sm font-normal text-text-secondary">{{ message() }}</span>
    }
    <ng-content></ng-content>
  </div>

  <div class="ui-alert-actions">
    @if (secondaryAction()) {
      <ui-button
        class="ui-alert-secondary-action"
        [size]="buttonSize()"
        [isDarkMode]="type() === 'system'"
        [label]="secondaryAction()!.label"
        (onClick)="secondaryAction()!.onClick()"
        [variant]="secondaryActionVariant()"
        [loading]="secondaryAction()!.loading || false"
        [loadingLabel]="secondaryAction()!.loadingLabel || 'Loading'" />
    }

    @if (action()) {
      <ui-button
        [size]="buttonSize()"
        [label]="action()!.label"
        (onClick)="action()!.onClick()"
        [variant]="actionVariant()"
        [loading]="action()!.loading || false"
        [loadingLabel]="action()!.loadingLabel || 'Loading'" />
    }
  </div>

  @if (!hideCloseButton()) {
    <ui-close class="ui-alert-close-icon" [isDarkMode]="type() === 'system'" (onClick)="onClose.emit()"></ui-close>
  }
</div>
